import { render } from "./HospitalGlobalSettings.vue?vue&type=template&id=0c91c382&scoped=true"
import script from "./HospitalGlobalSettings.vue?vue&type=script&lang=js"
export * from "./HospitalGlobalSettings.vue?vue&type=script&lang=js"

import "./HospitalGlobalSettings.vue?vue&type=style&index=0&id=0c91c382&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c91c382"]])

export default __exports__